(() => {
  const config = window.loyaltyConfig || {};

  const MOCK_STATE = {
    wallet: { balance: 825, lifetimeEarned: 1640, lifetimeSpent: 815, level: 'Silver', nextLevel: 'Gold', levelProgress: 68 },
    games: [
      { id: 'collection-clash', name: 'Collection Clash', category: 'Idle battler', description: 'Kies twee defenders en twee attackers en bepaal tijdens het gevecht je prioriteitsdoelen.', playTime: '3–5 min', reward: 'Geen punten', attemptsUsed: 0, dailyLimit: 0, featured: true, href: '/pages/card-match' },
      { id: 'pack-sort', name: 'Pack Sort', category: 'Snelheid', description: 'Sorteer de booster packs in de juiste serie.', playTime: '1 min', reward: 'Tot 8 punten', attemptsUsed: 0, dailyLimit: 5, featured: false, comingSoon: true },
      { id: 'tcg-trivia', name: 'TCG Trivia', category: 'Kennis', description: 'Test je kennis van kaarten, sets en verzamelaars.', playTime: '3 min', reward: 'Tot 12 punten', attemptsUsed: 1, dailyLimit: 3, featured: false, comingSoon: true }
    ],
    giveaways: [],
    quests: [
      { id: 'daily-games', name: 'Speel 2 games', type: 'Dagelijks', progress: 1, goal: 2, reward: 10 },
      { id: 'weekly-days', name: 'Speel op 4 verschillende dagen', type: 'Wekelijks', progress: 2, goal: 4, reward: 50 },
      { id: 'first-order', name: 'Plaats een kwalificerende bestelling', type: 'Shop', progress: 0, goal: 1, reward: 25 }
    ],
    achievements: [
      { id: 'first-game', name: 'Eerste Game', description: 'Je eerste Arcade-game gespeeld.', unlocked: true, icon: '★' },
      { id: 'ten-games', name: 'Arcade Regular', description: 'Speel 10 games.', unlocked: true, icon: '10' },
      { id: 'first-reward', name: 'Eerste Reward', description: 'Claim je eerste reward.', unlocked: false, icon: '◆' }
    ],
    rewards: [
      { id: 'pokemon-booster', name: 'Pokémon Booster', type: 'PHYSICAL_PRODUCT', cost: 500, available: true, availableQuantity: 8, physical: true },
      { id: 'promo-card', name: 'Promo Card', type: 'PHYSICAL_PRODUCT', cost: 300, available: true, availableQuantity: 3, physical: true },
      { id: 'discount-5', name: '€5 shoptegoed', type: 'DISCOUNT', cost: 600, available: true, physical: false }
    ],
    vault: [
      { id: 'vault-1', name: 'Pokémon Booster', quantity: 2, status: 'AVAILABLE', claimedAt: '2026-09-18', expiresAt: new Date(Date.now() + 6 * 86400000).toISOString() },
      { id: 'vault-2', name: 'Promo Card', quantity: 1, status: 'RESERVED', claimedAt: '2026-09-21' }
    ],
    transactions: [
      { id: 'tx-1', amount: 125, type: 'ORDER', description: 'Bestelling #1042', date: '2026-09-22' },
      { id: 'tx-2', amount: 10, type: 'GAME', description: 'Card Match', date: '2026-09-21' },
      { id: 'tx-3', amount: 20, type: 'QUEST', description: 'Dagelijkse quest', date: '2026-09-20' },
      { id: 'tx-4', amount: -500, type: 'REDEMPTION', description: 'Pokémon Booster', date: '2026-09-18' }
    ],
    gameHistory: [
      { id: 'game-1', name: 'Card Match', score: 8200, points: 10, date: '2026-09-21' },
      { id: 'game-2', name: 'TCG Trivia', score: 7, points: 8, date: '2026-09-20' }
    ]
  };

  const clone = (value) => JSON.parse(JSON.stringify(value));
  const pause = (value) => new Promise((resolve) => window.setTimeout(() => resolve(clone(value)), 180));

  class MockRewardsAPI {
    constructor() {
      this.state = clone(MOCK_STATE);
      this.sessions = new Map();
    }

    async getOverview() {
      return pause(this.state);
    }

    async getCollection() {
      return pause({ enabled: true, sets: [], cards: [], packs: [], availablePacks: [] });
    }

    async getWallet() { return pause(this.state.wallet); }
    async getGames() { return pause(this.state.games); }
    async getVault() { return pause(this.state.vault); }
    async getRewards() { return pause(this.state.rewards); }
    async getCartRewards(subtotalCents) {
      const items = this.state.vault.filter((item) => item.status === 'AVAILABLE').map((item) => ({ ...item, minimumOrderCents: 2500, eligible: Number(subtotalCents) >= 2500 }));
      return pause({ subtotalCents: Number(subtotalCents), eligibleCount: items.filter((item) => item.eligible).reduce((sum, item) => sum + Number(item.quantity || 1), 0), waitingCount: items.filter((item) => !item.eligible).reduce((sum, item) => sum + Number(item.quantity || 1), 0), nextMinimumCents: items.some((item) => !item.eligible) ? 2500 : null, items });
    }
    async trackProductView() { return pause({ ok: true, mock: true }); }
    async exportPrivacyData() { return pause({ exportedAt: new Date().toISOString(), mock: true, profile: { note: 'Demo-export' } }); }
    async requestPrivacyErasure() { return pause({ ok: true, status: 'PENDING', message: 'Demo-verwijderverzoek ontvangen.' }); }
    async enterGiveaway() { throw new Error('Giveaways zijn niet beschikbaar in de demomodus.'); }
    async openCollectionPack() { throw new Error('Pack opening is niet beschikbaar in de demomodus.'); }
    async buyCollectionPack() { throw new Error('Packs kopen is niet beschikbaar in de demomodus.'); }
    async exchangeCollectionDuplicates() { throw new Error('Duplicaten inwisselen is niet beschikbaar in de demomodus.'); }

    async startGame(gameId) {
      const id = window.crypto?.randomUUID?.() || `mock-${Date.now()}-${Math.random().toString(16).slice(2)}`;
      const session = {
        id,
        gameId,
        startedAt: Date.now(),
        expiresAt: Date.now() + 10 * 60 * 1000,
        rewardEligible: Boolean(config.isAuthenticated && config.flags?.gamePoints)
      };
      this.sessions.set(id, session);
      return pause(session);
    }

    async finishGame(sessionId, result) {
      const session = this.sessions.get(sessionId);
      if (!session || session.completedAt) throw new Error('Deze gamesessie is verlopen of al voltooid.');
      session.completedAt = Date.now();
      const duration = session.completedAt - session.startedAt;
      const plausible = duration >= 3000 && Number(result?.moves) >= 6 && Number(result?.score) >= 0;
      const pointsAwarded = session.rewardEligible && plausible ? Math.min(10, Math.max(1, Math.floor(Number(result.score) / 1000))) : 0;
      if (pointsAwarded) {
        this.state.wallet.balance += pointsAwarded;
        this.state.wallet.lifetimeEarned += pointsAwarded;
      }
      return pause({ success: plausible, score: Number(result?.score) || 0, pointsAwarded, newBalance: this.state.wallet.balance, mock: true });
    }

    async claimReward(rewardId) {
      if (!config.isAuthenticated) throw new Error('Log in om rewards te claimen.');
      const reward = this.state.rewards.find((item) => item.id === rewardId);
      if (!reward?.available) throw new Error('Deze reward is niet beschikbaar.');
      if (this.state.wallet.balance < reward.cost) throw new Error('Je hebt niet genoeg punten.');
      this.state.wallet.balance -= reward.cost;
      if (reward.physical) {
        this.state.vault.unshift({ id: `mock-vault-${Date.now()}`, name: reward.name, quantity: 1, status: 'AVAILABLE', claimedAt: new Date().toISOString().slice(0, 10), expiresAt: new Date(Date.now() + 7 * 86400000).toISOString() });
      }
      return pause({ success: true, newBalance: this.state.wallet.balance, mock: true });
    }
  }

  class CloudflareRewardsAPI {
    constructor(baseUrl) { this.baseUrl = String(baseUrl || '').replace(/\/$/, ''); }
    async request(path, options = {}) {
      const response = await fetch(`${this.baseUrl}${path}`, { credentials: 'include', headers: { 'Content-Type': 'application/json', ...(options.headers || {}) }, ...options });
      const body = await response.json().catch(() => null);
      if (!response.ok) throw new Error(body?.error || 'De loyaltyservice is tijdelijk niet beschikbaar.');
      return body;
    }
    getOverview() { return this.request('/me'); }
    getCollection(setSlug = '') { return this.request(`/collection${setSlug ? `?set=${encodeURIComponent(setSlug)}` : ''}`); }
    async getWallet() { return this.request('/wallet'); }
    async getGames() { return (await this.getOverview()).games; }
    async getVault() { return (await this.getOverview()).vault; }
    async getRewards() { return (await this.getOverview()).rewards; }
    async getCartRewards(subtotalCents) { return this.request(`/cart-rewards?subtotal_cents=${encodeURIComponent(String(Math.max(0, Number(subtotalCents) || 0)))}`); }
    trackProductView(productId) {
      return this.request('/events/product-view', {
        method: 'POST',
        body: JSON.stringify({ productId: String(productId) })
      });
    }
    exportPrivacyData() { return this.request('/privacy/export'); }
    requestPrivacyErasure() {
      return this.request('/privacy/erasure-request', {
        method: 'POST',
        body: JSON.stringify({ confirmation: 'VERWIJDER' })
      });
    }
    startGame() { return Promise.reject(new Error('Games zijn momenteel uitgeschakeld.')); }
    finishGame() { return Promise.reject(new Error('Games zijn momenteel uitgeschakeld.')); }
    claimReward(rewardId) {
      const idempotencyKey = window.crypto?.randomUUID?.() || `claim-${Date.now()}-${Math.random().toString(16).slice(2)}`;
      return this.request(`/rewards/${encodeURIComponent(rewardId)}/claim`, {
        method: 'POST',
        headers: { 'Idempotency-Key': idempotencyKey }
      });
    }
    enterGiveaway(giveawayId, instagramConfirmed = false) {
      const idempotencyKey = window.crypto?.randomUUID?.() || `giveaway-${Date.now()}-${Math.random().toString(16).slice(2)}`;
      return this.request(`/giveaways/${encodeURIComponent(giveawayId)}/enter`, {
        method: 'POST',
        headers: { 'Idempotency-Key': idempotencyKey },
        body: JSON.stringify({ instagramConfirmed: Boolean(instagramConfirmed) })
      });
    }
    openCollectionPack(packInstanceId) {
      const idempotencyKey = window.crypto?.randomUUID?.() || `pack-open-${Date.now()}-${Math.random().toString(16).slice(2)}`;
      return this.request(`/collection/packs/${encodeURIComponent(packInstanceId)}/open`, {
        method: 'POST',
        headers: { 'Idempotency-Key': idempotencyKey }
      });
    }
    buyCollectionPack(packSlug) {
      const idempotencyKey = window.crypto?.randomUUID?.() || `pack-buy-${Date.now()}-${Math.random().toString(16).slice(2)}`;
      return this.request(`/collection/packs/${encodeURIComponent(packSlug)}/buy`, {
        method: 'POST',
        headers: { 'Idempotency-Key': idempotencyKey }
      });
    }
    exchangeCollectionDuplicates(packSlug) {
      const idempotencyKey = window.crypto?.randomUUID?.() || `pack-exchange-${Date.now()}-${Math.random().toString(16).slice(2)}`;
      return this.request(`/collection/packs/${encodeURIComponent(packSlug)}/exchange`, {
        method: 'POST',
        headers: { 'Idempotency-Key': idempotencyKey }
      });
    }
  }

  window.RewardsAPI = config.mockMode ? new MockRewardsAPI() : new CloudflareRewardsAPI(config.apiUrl);
  window.MockRewardsAPI = MockRewardsAPI;
  window.CloudflareRewardsAPI = CloudflareRewardsAPI;
})();
